
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTwowayAcuatorGeneral25 as ObiTwowayAcuatorGeneral25Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-twoway-acuator-general-25.js';
 
 
 

 
 export const ObiTwowayAcuatorGeneral25 = createComponent({
   react: React,
   tagName: 'obi-twoway-acuator-general-25',
   elementClass: ObiTwowayAcuatorGeneral25Element,
   events: {
     
   }
  });
 
 